<script setup>
import FeatureFlag from '/app/components/FeatureFlag.vue';
import Icon from '/app/components/NIcon.vue';
import { useRoute } from 'vue-router';
import { usePlatform } from '/app/composables/platform';
import { useAuth } from '/app/composables/auth';
import { computed } from 'vue';

const route = useRoute();
const { auth } = useAuth();
const handle = computed(() => route.params.platformSlug);
const { platform, isBignerve, isUserPlatform } = usePlatform();
const currentUser = computed(() => auth.current);
</script>

<template>
    <div class="page__sidebar-inside" data-heap-id="dashboard-sidebar">
        <ul>
            <li class="non-functional">
                <RouterLink :to="{ name: 'dashboard.messages', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="messages">
                    <Icon as="comments-solid" class="inline-block w-[1.5rem]" />
                    Message Center
                </RouterLink>
            </li>
            <li>
                <RouterLink :to="{ name: 'dashboard.innovator', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="ideas">
                    <Icon as="innovator" class="inline-block w-[1.5rem] pl-[.2rem]" />
                    My Ideas
                </RouterLink>
            </li>
            <li>
                <RouterLink :to="{ name: 'dashboard.mentoring', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="mentoring">
                    <Icon as="mentor" class="inline-block w-[1.5rem]" />
                    My Mentoring
                </RouterLink>
            </li>
            <li>
                <RouterLink :to="{ name: 'dashboard.catalyst.open.task-queue', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="questions">
                    <Icon as="catalyst" class="inline-block w-[1.5rem]" />
                    My Questions
                </RouterLink>
                <ul class="non-functional">
                    <li>
                        <RouterLink :to="{ name: 'challenges.create' }" active-class="!text-nerve"
                            data-heap-id="dashboard-sidebar-link" data-heap-target="ask-question">
                            Ask a Question
                        </RouterLink>
                    </li>
                    <li>
                        <RouterLink :to="{ name: 'challenges.create' }" active-class="!text-nerve"
                            data-heap-id="dashboard-sidebar-link" data-heap-target="test-idea">
                            Test an Idea
                        </RouterLink>
                        <!-- TO DO: add router link to TEST IDEA category flow directly -->
                    </li>
                </ul>
            </li>
            <li>
                <RouterLink :to="{ name: 'dashboard.rater', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="ratings">
                    <Icon as="rater" class="inline-block w-[1.5rem]" />
                    My Ratings
                </RouterLink>
            </li>
            <li>
                <RouterLink :to="{ name: 'dashboard.scouting', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="players">
                    <Icon as="scout" class="inline-block w-[1.5rem]" />
                    My Players
                </RouterLink>
            </li>
            <li>
                <RouterLink :to="{ name: 'dashboard.money-prizes', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="money-prizes">
                    <Icon as="money-bill-alt-regular" class="inline-block text-md w-[1.5rem]" />
                    Money &amp; Prizes
                </RouterLink>
            </li>
            <li class="non-functional">
                <RouterLink :to="{ name: 'dashboard.insightful', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="insightful">
                    <Icon as="insightful" class="inline-block w-[1.5rem]" />
                    Insightful
                </RouterLink>
            </li>
            <FeatureFlag flag="director-dashboard">
                <li>
                    <RouterLink :to="{ name: 'dashboard.director', params: { platformSlug: handle } }"
                        active-class="!text-nerve"
                        data-heap-id="dashboard-sidebar-link" data-heap-target="director">
                        <Icon as="director" class="inline-block w-[1.5rem]" />
                        Director
                    </RouterLink>
                    <ul class="non-functional">
                        <li>
                            <RouterLink :to="{ name: 'dashboard.director', params: { platformSlug: handle } }"
                                active-class="!text-nerve"
                                data-heap-id="dashboard-sidebar-link" data-heap-target="director-olympiad">
                                My Olympiad
                            </RouterLink>
                        </li>
                        <li>Custom Settings</li>
                        <li>
                            <RouterLink :to="{ name: 'dashboard.suggestion-box', params: { platformSlug: handle } }"
                                active-class="!text-nerve"
                                data-heap-id="dashboard-sidebar-link" data-heap-target="suggestion-box">
                                QQs <span class="sub ml-0">- Suggestion Box</span>
                            </RouterLink>
                        </li>
                        <li>
                            ReNerves &amp; Subscriptions
                        </li>
                    </ul>
                </li>
            </FeatureFlag>
            <li class="non-functional">
                <RouterLink :to="{ name: 'dashboard.notifications', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="game-dash-notifications">
                    <strong>Game Dash Notifications</strong>
                </RouterLink>
            </li>

            <li>
                <RouterLink :to="{ name: 'dashboard.notifications', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="game-dash">
                    <Icon as="bell" class="inline-block w-[1.5rem]" /> Game Dash
                </RouterLink>
            </li>

            <li>
                <RouterLink :to="{ name: 'dashboard.my-progress.score-stats', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="scores-stats">
                    <Icon as="brain" class="inline-block w-[1.5rem]" />
                    Scores &amp; Stats
                </RouterLink>
            </li>
            <li non-functional>
                <RouterLink :to="{ name: 'dashboard.my-progress', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="my-progress">
                    <Icon as="kpi-chart" class="inline-block w-[1.5rem]" />
                    My Progress
                </RouterLink>
                <ul>
                    <li class="non-functional">
                        <RouterLink :to="{ name: 'dashboard.leaderboards', params: { platformSlug: handle } }"
                            active-class="!text-nerve"
                            data-heap-id="dashboard-sidebar-link" data-heap-target="leaderboards">
                            Leaderboards
                        </RouterLink>
                    </li>
                    <li class="non-functional">
                        <RouterLink :to="{ name: 'dashboard.impact', params: { platformSlug: handle } }"
                            active-class="!text-nerve"
                            data-heap-id="dashboard-sidebar-link" data-heap-target="impact">
                            My Impact
                        </RouterLink>
                    </li>
                    <li class="non-functional">
                        <RouterLink :to="{ name: 'dashboard.awards', params: { platformSlug: handle } }"
                            active-class="!text-nerve"
                            data-heap-id="dashboard-sidebar-link" data-heap-target="awards">
                            Awards &amp; Badges
                        </RouterLink>
                    </li>
                </ul>
            </li>
            <li class="non-functional">
                <RouterLink :to="{ name: 'dashboard.friends', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="friends">
                    Friends &amp; Following
                </RouterLink>
            </li>
            <li class="non-functional">
                <RouterLink :to="{ name: 'dashboard.my-labs', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="teams">
                    My Teams <span class="sub ml-0">- Idea Labs</span>
                </RouterLink>
            </li>
            <li class="non-functional">
                <RouterLink :to="{ name: 'dashboard.nerve-on-ah.public', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="nerve-on-ah">
                    <strong>Nerv On Ah</strong> <span class="icon icon-code-fork" aria-hidden="true"></span>
                </RouterLink>
                <ul>
                    <li>
                        <RouterLink :to="{ name: 'dashboard.nerve-on-ah.public', params: { platformSlug: handle } }"
                            active-class="!text-nerve"
                            data-heap-id="dashboard-sidebar-link" data-heap-target="nerve-on-ah-public">
                            <span class="sub ml-0">Closed Challenges: Public </span>
                        </RouterLink>
                    </li>

                    <li>
                        <RouterLink :to="{ name: 'dashboard.nerve-on-ah.private', params: { platformSlug: handle } }"
                            active-class="!text-nerve"
                            data-heap-id="dashboard-sidebar-link" data-heap-target="nerve-on-ah-private">
                            <span class="sub ml-0">Closed Challenges: Private </span>
                        </RouterLink>
                    </li>
                </ul>
            </li>
        </ul>
        <ul class="non-functional">
            <li><a href="/discovernervus" class="" data-heap-id="dashboard-sidebar-link" data-heap-target="nerv-us-system">Nerv Us System</a></li>
            <li>
                <RouterLink :to="{ name: 'dashboard.idea-log', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="idea-log">
                    My Idea Log
                </RouterLink>
            </li>
            <li>
                <RouterLink :to="{ name: 'dashboard.resume', params: { platformSlug: handle } }"
                    active-class="!text-nerve"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="resume">
                    My Innovation Resume
                </RouterLink>
            </li>
            <li><a href="#" class="disabled">Money</a></li>
            <li><a href="#" class="disabled">Patron Funding</a></li>
            <li><a href="#" class="disabled">Projects &amp; Prototypes</a></li>
        </ul>

        <div class="border-t my-3 border-dashed"></div>
        <ul>
            <li>
                <RouterLink :to="{ name: 'dashboard.forum-preferences' }"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="forum-preferences">
                    <Icon as="cog" class="inline-block w-[1.5rem] text-center" />
                    Forum Preferences
                </RouterLink>
            </li>
            <li>
                <RouterLink :to="{ name: 'dashboard.forum-tools' }"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="forum-tools">
                    <Icon as="discussion" class="inline-block w-[1.5rem] text-center" />
                    Forum Tools
                </RouterLink>
            </li>
            <FeatureFlag flag="discussion-forums-attachments">
                <li>
                    <RouterLink :to="{ name: 'dashboard.my-files' }"
                        data-heap-id="dashboard-sidebar-link" data-heap-target="media-storage">
                        <Icon as="images" class="inline-block w-[1.5rem] text-center" />
                        Media Storage
                    </RouterLink>
                </li>
            </FeatureFlag>
        </ul>
        <div class="border-t my-3  border-dashed"></div>
        <em class="mb-2">Shortcuts:</em>
        <ul class="!pl-4">
            <li :class="{ disabled: !currentUser.user.id }">
                <RouterLink :to="{ name: 'account.my-account' }"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="my-account">
                    My Account
                </RouterLink>
            </li>
            <li :class="{ disabled: !currentUser.user.id }">
                <RouterLink :to="{ name: 'discussion-forums.topics.all', params: { platformSlug: handle } }"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="my-forum">
                    My Forum
                </RouterLink>
            </li>
            <li>
                <a href="/nerve-boards" data-heap-id="dashboard-sidebar-link" data-heap-target="nerve-boards">Nerve Boards</a><!-- to fix later -->
            </li>
            <li>
                <RouterLink :to="{ name: 'faqs' }"
                    data-heap-id="dashboard-sidebar-link" data-heap-target="faqs">FAQs</RouterLink>
            </li>
        </ul>
    </div>
</template>
